//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        goUrl(item) {
            this.$sendCtmEvtLog(`购房流程-【${item.name}】点击`)
            wx.navigateTo({
                url: item.url
            })
        }
    },
    computed: {
        tabs () {
            return [
                {
                    icon: 'condition',
                    name: '购房资格查询',
                    url: '/check_condition'
                },
                // {
                //     icon: 'qualification',
                //     name: '查落户资格',
                //     url: '/personal_package/verify_qualification/main'
                // },
                {
                    icon: 'step',
                    name: '登记步骤',
                    url: '/reg_step'
                },
                {
                    icon: 'qa',
                    name: '常见问题',
                    url: '/personal_package/qa/main',
                },
                // {
                //     icon: 'history',
                //     name: '即将预售楼盘',
                //     url: '/list/forthcoming/main',
                // },
                // {
                //     icon: 'buildings',
                //     name: '一键找房',
                //     url: '/packageA/whole_buildings/main',
                // },
                // {
                //     icon: 'map',
                //     name: '地图找房',
                //     url: '/packageA/whole_buildings_map/main'
                // },
                // {
                //     icon: 'computer',
                //     name: '房贷计算',
                //     url: '/packageA/loan_computer/main'
                // },
                // {
                //     icon: 'first_payment',
                //     name: '首付测试',
                //     url: '/packageA/first_payment/main'
                // },
                // {
                //     icon: 'provident_fund',
                //     name: '算公积金额度',
                //     url: '/packageB/provident_fund/main'
                // },
                // {
                //     icon: 'assistant',
                //     name: '拉群助手',
                //     url: '/personal_package/group_assistant/main'
                // },
                // {
                //     icon: 'weixin',
                //     name: '官方公众号',
                //     url: '/personal_package/official_weixin/main'
                // }
            ]
        }
    }
}
